export default __webpack_public_path__ + "static/media/step-one.59cad269.png";